import * as React from 'react';
import { MenuItem, TextField } from '@mui/material';

import { codeLabel, comboLabel, simpleLabel } from '../core/corecombo';
export class GridCodeCombo extends React.Component<any> {

  onChange = (event:any) => {
    const { id, field, api } = this.props;
    const newValue = event?.target?.value;

    // Call setEditCellValue directly from the injected api object
    api.setEditCellValue({ id, field, value: newValue });
  };

  render(){
    const {label, items = [], value = '',type='SIMPLE'} = this.props;
    const t = type?.toUpperCase();
    const labelFn = t==='CODE'?codeLabel:t==='COMBO'?comboLabel:simpleLabel;
    
    return (
      <TextField
        select
        size="small"
        label={label}
        value={value||''}
        onChange={this.onChange}
        fullWidth
        autoFocus
      >
        <MenuItem value="">Select...</MenuItem>
        {items.map((x:any) => (
          <MenuItem key={x.shc} value={x.shc}>{labelFn(x)}</MenuItem>
        ))}
      </TextField>
    );
  }
}

